import html2canvas from "html2canvas";

const DownloadGraph = async (ref, fileName = "chart") => {
  if (!ref?.current) return;

  try {
    const chartElement =
      ref.current.querySelector(".recharts-wrapper") || ref.current;

    await new Promise((resolve) => requestAnimationFrame(resolve));

    const width = chartElement.scrollWidth;
    const height = chartElement.scrollHeight;

    const canvas = await html2canvas(chartElement, {
      backgroundColor: "#ffffff",
      scale: 3,
      useCORS: true,
      logging: false,
      width,
      height,
      windowWidth: width,
      windowHeight: height,
      scrollX: 0,
      scrollY: 0
    });

    const link = document.createElement("a");
    link.download = `${fileName}_${Date.now()}.png`;
    link.href = canvas.toDataURL("image/png");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } catch (error) {
    console.error("Download failed:", error);
  }
};

export default DownloadGraph;
